var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1392.7 851.6",
    style: {
      enableBackground: "new 0 0 1392.7 851.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F8BB21;}\r\n\t.st1{opacity:0.49;fill:#CC9C3B;enable-background:new    ;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_00000053516332838910050220000004325084982295248811_);}\r\n\t.st4{opacity:0.44;fill:#F8BB21;enable-background:new    ;}\r\n\t.st5{opacity:0.44;}\r\n\t.st6{fill:url(#SVGID_00000139287922239551433950000000264651319432455591_);}\r\n\t.st7{opacity:0.56;}\r\n\t.st8{fill:#775C10;}\r\n\t.st9{fill:url(#SVGID_00000067956338528444028320000008831668662288696222_);}\r\n\t.st10{fill:url(#SVGID_00000178168420911618186180000009801087852078334624_);}\r\n\t.st11{fill:url(#SVGID_00000096776804709390157020000003540004613181632442_);}\r\n\t.st12{fill:url(#SVGID_00000107575623743986621500000009054170925276059817_);}\r\n\t.st13{fill:url(#SVGID_00000164477781242297431590000013752694369074811314_);}\r\n\t.st14{fill:url(#SVGID_00000135661849755478820970000009221698843430061448_);}\r\n\t.st15{fill:url(#SVGID_00000067945130084661852370000012853531246302072234_);}\r\n\t.st16{opacity:0.44;fill:url(#SVGID_00000183929059311588005030000015119357307688876469_);enable-background:new    ;}\r\n\t.st17{fill:#8C1919;}\r\n\t.st18{fill:#FF2A00;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000101803865103980970940000006941674834805483653_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.5,30.3h1238.9c25.6,0,46.4,20.8,46.4,46.4l0,0V764c0,25.6-20.8,46.4-46.4,46.4l0,0H74.5 c-25.6,0-46.4-20.8-46.4-46.4c0,0,0,0,0,0V76.7C28.1,51,48.9,30.3,74.5,30.3L74.5,30.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.5,30.3h1238.9c25.6,0,46.4,20.8,46.4,46.4l0,0V764c0,25.6-20.8,46.4-46.4,46.4l0,0H74.5 c-25.6,0-46.4-20.8-46.4-46.4c0,0,0,0,0,0V76.7C28.1,51,48.9,30.3,74.5,30.3L74.5,30.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 693.955,
    y1: 820.73,
    x2: 693.955,
    y2: 40.62,
    gradientTransform: "matrix(1 0 0 -1 0 851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#D1D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#AEAEAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#818181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#494949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.5,30.3h1238.9c25.6,0,46.4,20.8,46.4,46.4l0,0V764c0,25.6-20.8,46.4-46.4,46.4l0,0H74.5 c-25.6,0-46.4-20.8-46.4-46.4c0,0,0,0,0,0V76.7C28.1,51,48.9,30.3,74.5,30.3L74.5,30.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024712178815241011850000017645377659681040029_",
    gradientUnits: "userSpaceOnUse",
    x1: 693.955,
    y1: 50.89,
    x2: 693.955,
    y2: 37.88,
    gradientTransform: "matrix(1 0 0 -1 0 851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8A325"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#D3A123"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#C49A1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B99619"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024712178815241011850000017645377659681040029_)"
    },
    d: "M74.5,30.3h1238.9 c25.6,0,46.4,20.8,46.4,46.4l0,0V764c0,25.6-20.8,46.4-46.4,46.4l0,0H74.5c-25.6,0-46.4-20.8-46.4-46.4c0,0,0,0,0,0V76.7 C28.1,51,48.9,30.3,74.5,30.3L74.5,30.3z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.3,55.6h1219.3c17.4,0,31.6,14.1,31.6,31.6v666.4c0,17.4-14.1,31.6-31.6,31.6H84.3 c-17.4,0-31.6-14.1-31.6-31.6V87.2C52.7,69.7,66.9,55.6,84.3,55.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152986037203393996110000003611046817059054487_",
    gradientUnits: "userSpaceOnUse",
    x1: 693.955,
    y1: 64.81,
    x2: 693.955,
    y2: 796.49,
    gradientTransform: "matrix(1 0 0 -1 0 851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#D1D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#AEAEAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#818181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#494949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152986037203393996110000003611046817059054487_)"
    },
    d: "M1285.3,55.6 c27.6,0,49.9,22.4,49.9,49.9c0,0,0,0,0,0v629.7c0,27.6-22.4,49.9-49.9,49.9l0,0H102.7c-27.6,0-49.9-22.4-49.9-49.9V105.5 c0-27.6,22.4-49.9,49.9-49.9H1285.3 M1285.3,54.6H102.7c-28.2,0-51,22.8-51,51v629.6c0,28.2,22.8,51,51,51h1182.6 c28.2,0,51-22.8,51-51V105.5C1336.3,77.3,1313.4,54.5,1285.3,54.6L1285.3,54.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88.7,61.5h1210.6c16.3,0,29.6,13.2,29.6,29.6v658.6c0,16.3-13.2,29.6-29.6,29.6H88.7 c-16.3,0-29.6-13.2-29.6-29.6V91C59.1,74.7,72.3,61.5,88.7,61.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046322940564045309440000000314609159987315335_",
    gradientUnits: "userSpaceOnUse",
    x1: 687.4199,
    y1: 798.1334,
    x2: 700.4901,
    y2: 63.1666,
    gradientTransform: "matrix(1 0 0 -1 0 851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8A6A14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#856812"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#846812"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046322940564045309440000000314609159987315335_)"
    },
    d: "M90.9,63.5H1297 c16.5,0,29.8,13.4,29.8,29.9v654c0,16.5-13.4,29.8-29.8,29.8H90.9c-16.5,0-29.9-13.4-29.9-29.8v-654C61,76.8,74.4,63.5,90.9,63.5 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029723997309042148480000017426426332898540184_",
    gradientUnits: "userSpaceOnUse",
    x1: 687.46,
    y1: 796.0891,
    x2: 700.4501,
    y2: 65.211,
    gradientTransform: "matrix(1 0 0 -1 0 851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E7818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#997616"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#927314"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029723997309042148480000017426426332898540184_)"
    },
    d: "M93.1,65.5h1201.8 c16.6,0,30.1,13.5,30.1,30.1v649.5c0,16.6-13.5,30.1-30.1,30.1H93.1c-16.6,0-30.1-13.5-30.1-30.1V95.6 C62.9,79,76.4,65.5,93.1,65.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107586455292979738720000010259359615157077655_",
    gradientUnits: "userSpaceOnUse",
    x1: 687.4949,
    y1: 794.0526,
    x2: 700.415,
    y2: 67.2475,
    gradientTransform: "matrix(1 0 0 -1 0 851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B1861C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#AC841A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9F7F16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107586455292979738720000010259359615157077655_)"
    },
    d: "M95.3,67.5h1197.4 c16.8,0,30.4,13.6,30.4,30.4v644.9c0,16.8-13.6,30.4-30.4,30.4H95.3c-16.8,0-30.4-13.6-30.4-30.4V97.9 C64.8,81.1,78.5,67.5,95.3,67.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163791160658697206550000013396341824341593507_",
    gradientUnits: "userSpaceOnUse",
    x1: 687.5249,
    y1: 792.0164,
    x2: 700.3751,
    y2: 69.2837,
    gradientTransform: "matrix(1 0 0 -1 0 851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C59521"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#C0931F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#B18C19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC8A17"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163791160658697206550000013396341824341593507_)"
    },
    d: "M97.5,69.5h1193 c17,0,30.7,13.7,30.7,30.7v640.3c0,17-13.7,30.7-30.7,30.7H97.5c-17,0-30.7-13.7-30.7-30.7V100.2C66.8,83.2,80.5,69.5,97.5,69.5z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103227482604000619940000014644995598748437905_",
    gradientUnits: "userSpaceOnUse",
    x1: 687.5601,
    y1: 789.9796,
    x2: 700.34,
    y2: 71.3204,
    gradientTransform: "matrix(1 0 0 -1 0 851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8A325"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#D3A123"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#C49A1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B99619"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103227482604000619940000014644995598748437905_)"
    },
    d: "M99.7,71.5h1188.6c17.1,0,31,13.9,31,31 v635.7c0,17.1-13.9,31-31,31H99.7c-17.1,0-31-13.9-31-31V102.5C68.7,85.4,82.5,71.5,99.7,71.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075862249549545157280000018420044427702578311_",
    gradientUnits: "userSpaceOnUse",
    x1: 687.61,
    y1: 787.9352,
    x2: 700.3099,
    y2: 73.3648,
    gradientTransform: "matrix(1 0 0 -1 0 851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ECB129"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#E7AF27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#D8A821"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C7A11B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075862249549545157280000018420044427702578311_)"
    },
    d: "M101.9,73.5H1286 c17.3,0,31.3,14,31.3,31.3v631.2c0,17.3-14,31.3-31.3,31.3H101.9c-17.3,0-31.3-14-31.3-31.3V104.8 C70.6,87.5,84.6,73.5,101.9,73.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092441389240399576440000008307328816808098184_",
    gradientUnits: "userSpaceOnUse",
    x1: 687.645,
    y1: 785.8989,
    x2: 700.275,
    y2: 75.4012,
    gradientTransform: "matrix(1 0 0 -1 0 851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFBF2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FABD2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#EAB625"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4AD1D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092441389240399576440000008307328816808098184_)"
    },
    d: "M104.1,75.5h1179.8 c17.4,0,31.6,14.1,31.6,31.6v626.6c0,17.4-14.1,31.6-31.6,31.6H104.1c-17.4,0-31.6-14.1-31.6-31.6V107.1 C72.5,89.6,86.6,75.5,104.1,75.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000029726465392954767020000007885280777463952567_",
    cx: 691.42,
    cy: 608.37,
    r: 672.18,
    gradientTransform: "matrix(1 0 0 -1 0 851)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#595959"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#4B494A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#333031"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "url(#SVGID_00000029726465392954767020000007885280777463952567_)",
      enableBackground: "new"
    },
    d: " M104.1,75.5h1179.8c17.4,0,31.6,14.1,31.6,31.6v626.6c0,17.4-14.1,31.6-31.6,31.6H104.1c-17.4,0-31.6-14.1-31.6-31.6V107.1 C72.5,89.6,86.6,75.5,104.1,75.5z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M148.8,30.3h-47.3c-40.5,0-73.3,32.8-73.3,73.3v34.5c0,5.7,4.7,10.4,10.4,10.4h10.4 c5.7,0,10.4-4.7,10.4-10.4v-30.4c0-25.7,20.9-46.6,46.6-46.6h42.9c5.7,0,10.4-4.7,10.4-10.4v-10C159.2,34.9,154.5,30.3,148.8,30.3 C148.8,30.3,148.8,30.3,148.8,30.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1286.5,30.3h-47.3c-5.7,0-10.4,4.7-10.4,10.4v10c0,5.7,4.7,10.4,10.4,10.4c0,0,0,0,0,0h42.8 c25.7,0,46.6,20.8,46.6,46.6c0,0,0,0,0,0v30.4c0,5.7,4.7,10.4,10.4,10.4h10.4c5.7,0,10.4-4.7,10.4-10.4v0v-34.5 C1359.8,63.1,1327,30.3,1286.5,30.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1349.4,692.2H1339c-5.7,0-10.4,4.7-10.4,10.4V733c0,25.7-20.8,46.6-46.5,46.6c0,0-0.1,0-0.1,0h-42.9 c-5.7,0-10.4,4.7-10.4,10.4v10c0,5.7,4.7,10.4,10.4,10.4h47.3c40.5,0,73.3-32.8,73.3-73.3v-34.5 C1359.8,696.8,1355.1,692.2,1349.4,692.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M148.8,779.6h-42.9c-25.7,0-46.6-20.8-46.6-46.5c0,0,0,0,0,0v-30.4c0-5.7-4.7-10.4-10.4-10.4c0,0,0,0,0,0 H38.5c-5.7,0-10.4,4.7-10.4,10.4v34.5c0,40.5,32.8,73.3,73.3,73.3h47.3c5.7,0,10.4-4.7,10.4-10.4l0,0v-10 C159.2,784.3,154.5,779.6,148.8,779.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1346.9,143c2.9,0,5.3-2.4,5.3-5.3s-2.4-5.3-5.3-5.3c-2.9,0-5.3,2.4-5.3,5.3c0,0,0,0,0,0 C1341.6,140.6,1343.9,143,1346.9,143z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1239.4,47.6c2.9,0,5.3-2.4,5.3-5.3s-2.4-5.3-5.3-5.3c-2.9,0-5.3,2.4-5.3,5.3c0,0,0,0,0,0 C1234.1,45.2,1236.5,47.6,1239.4,47.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M145.6,37c-2.9,0-5.3,2.4-5.3,5.4c0,2.9,2.4,5.3,5.4,5.3c2.9,0,5.3-2.4,5.3-5.4c0,0,0,0,0,0 C151,39.3,148.6,37,145.6,37z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M41.9,134c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3s5.3-2.4,5.3-5.3C47.2,136.4,44.8,134,41.9,134 C41.9,134,41.9,134,41.9,134z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1346.9,702.9c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3c2.9,0,5.3-2.4,5.3-5.3 C1352.2,705.3,1349.8,702.9,1346.9,702.9C1346.9,702.9,1346.9,702.9,1346.9,702.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1240.5,791c-2.9,0-5.3,2.4-5.3,5.3c0,2.9,2.4,5.3,5.3,5.4c2.9,0,5.3-2.4,5.3-5.3c0,0,0,0,0,0 C1245.9,793.4,1243.5,791,1240.5,791z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M41.9,704.5c-2.9,0-5.3,2.4-5.3,5.3c0,2.9,2.4,5.3,5.3,5.3c2.9,0,5.3-2.4,5.3-5.3c0,0,0,0,0,0 C47.2,706.9,44.8,704.5,41.9,704.5C41.9,704.5,41.9,704.5,41.9,704.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M145.2,794c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3s5.3-2.4,5.3-5.3S148.2,794,145.2,794L145.2,794z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionBox);
export default __webpack_public_path__ + "static/media/question-box.0f1f4a8561654c5e0655e311ac6db58c.svg";
export { ForwardRef as ReactComponent };